import { usePageMeta } from "../hooks/usePageMeta";
import { FadeIn } from "../components/site/FadeIn";
import { SectionHeading } from "../components/site/SectionHeading";
import { StatTile } from "../components/site/StatTile";
import { PublicationRow } from "../components/site/PublicationRow";
import { JOURNAL_ARTICLES, CONFERENCE_PAPERS } from "../data/publications";
import { CONFIG } from "../data/config";

export default function Publications() {
  usePageMeta(
    "Publications — Keyur Sorathia",
    "Fifty-one peer-reviewed publications in HCI, virtual reality and immersive learning."
  );
  return (
    <div data-testid="publications-page">
      <section className="section">
        <div className="container-site">
          <FadeIn>
            <h1 className="text-h1 mb-6" style={{ color: "var(--navy-700)" }}>Fifty-one peer-reviewed publications</h1>
            <p className="body-lg measure mb-12">
              Nine refereed journal articles and forty-two refereed conference papers and book chapters.
            </p>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-testid="publications-tiles">
            <StatTile value="51" label="peer-reviewed publications, nine journal and forty-two conference or chapter" />
            <StatTile value="11" label="h-index" />
            <StatTile value="13" label="i10-index" />
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Journals" title="Journal articles" />
          </FadeIn>
          <ul className="m-0 p-0" data-testid="journal-list">
            {JOURNAL_ARTICLES.map((pub) => (
              <PublicationRow key={pub.title} pub={pub} />
            ))}
          </ul>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Conferences" title="Selected conference papers" />
          </FadeIn>
          <ul className="m-0 p-0" data-testid="conference-list">
            {CONFERENCE_PAPERS.map((pub) => (
              <PublicationRow key={pub.title} pub={pub} />
            ))}
          </ul>
          <p className="mt-10">
            <a href={CONFIG.scholarUrl} target="_blank" rel="noopener noreferrer" className="link-default font-medium" data-testid="publications-scholar-link">
              Google Scholar profile
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
